export const shippingMethodListProps = () => ({
  modesCommande: {
    type: Array,
    required: true
  },
  selectedModeCommandeType: {
    type: String,
    required: false,
    default: null
  },
  typeModeCommandeHabituel: {
    type: String,
    required: false
  }
})

export const shippingMethodListEmits = () => ([
  "modeCommandeSelected",
  "serviceSelected",
  "showOrderDetail"
])

export const useShippingMethodList = (props, context) => {
  const modeCommandeHabituel = computed(() => {
    if (props.typeModeCommandeHabituel) {
      return props.modesCommande.find(mdc => mdc.type === props.typeModeCommandeHabituel);
    }
    return null;
  })
  const otherModesCommande = computed(() => {
    if (props.typeModeCommandeHabituel) {
      return props.modesCommande.filter(mdc => mdc.type !== props.typeModeCommandeHabituel);
    }
    return props.modesCommande;
  })

  const modeCommandeSelected = (mdc) => {
    context.emit("modeCommandeSelected", mdc.type);
  }
  const serviceSelected = (id) => {
    context.emit("serviceSelected", id);
  }
  const showOrderDetail = () => {
    context.emit("showOrderDetail");
  }

  return { modeCommandeHabituel, otherModesCommande, modeCommandeSelected, serviceSelected, showOrderDetail }
}